<template>
  <div class="d-flex py-2 align-items-center justify-content-between">
    <span
      class="document__name__status col-6 co-md-8 d-flex flex-column flex-md-row align-items-md-center justify-content-between"
    >
      <span
        class="document-name body-strong text-grey-900 col-12 col-md-8 skeleton-text shimmer"
      >
      </span>
      <span
        class="document-status caption text-grey-900 col-12 col-md-4 skeleton-text mt-1 shimmer"
      >
      </span>
    </span>
    <span
      class="document-download d-flex align-items-center gap-1 col-6 col-md-4 link-small justify-content-end skeleton-text shimmer"
    >
    </span>
  </div>
</template>

<script lang="ts" setup></script>

<style scoped>
  .document-name {
    height: 30px;
  }

  .document-status {
    height: 8px;
    width: 40px;
  }

  .document-download {
    height: 21px;
    width: 100px;
  }
</style>
